export default __webpack_public_path__ + "static/media/start-k-8.1e4e1e00.jpg";